
import React from "react";
import { UI_BODY_DF, UI_BODY_SM_DF } from "oolib";

export const NoOptionResultsComp = ({S}) => {
    const TYPO_COMP = S ? UI_BODY_SM_DF : UI_BODY_DF

    return (
        <div style={{ padding: '1.2rem 0.8rem' }}>
            <TYPO_COMP style={{ fontStyle: "italic" }}>No Results!</TYPO_COMP>
        </div>
    )
}
